// Same-day mark for every cart line, however it was added (our forms already add it; this covers the
// related-products app and any other widget). Marks lines whose product is in the sameday-delivery collection,
// and gives every line its "_SUPPLIER" (metafield custom.supplier via ?view=bjo-supplier; kept out of page HTML so competitors cannot read our suppliers from the source).
(() => {
  const KEY = '_SAMEDAY ITEM', VAL = '✔', OLD = '_Delivery', SUP = '_SUPPLIER';
  const origFetch = window.fetch.bind(window);
  const sameDayIds = async () => {
    try {
      const c = JSON.parse(localStorage.getItem('bjoSD') || 'null');
      if (c && Date.now() - c.t < 6 * 3600e3) return new Set(c.ids);
    } catch (e) {}
    const ids = [];
    for (let page = 1; page <= 10; page++) { // ponytail: ~1000 products = 4 requests, cached 6h; only runs when a line lacks the mark
      const r = await origFetch('/collections/sameday-delivery/products.json?limit=250&page=' + page);
      if (!r.ok) break;
      const j = await r.json();
      j.products.forEach((p) => ids.push(p.id));
      if (j.products.length < 250) break;
    }
    try { localStorage.setItem('bjoSD', JSON.stringify({ t: Date.now(), ids })); } catch (e) {}
    return new Set(ids);
  };
  // Same item added twice with nothing different the customer can see (no gift wrap, no note) = one line, qty summed.
  // Lines split when hidden bits differ (_SUPPLIER added later, an empty "Gift Wrap: No" from the wrap app, ...).
  const shown = (it) => JSON.stringify(Object.entries(it.properties || {})
    .filter(([k, v]) => k[0] !== '_' && String(v).trim() !== '' && !(k === 'Gift Wrap' && /^no$/i.test(String(v).trim())))
    .sort());
  const merge = async () => {
    const cart = await (await origFetch('/cart.js')).json();
    const seen = {}, updates = {};
    for (const it of cart.items) {
      if (it.properties && it.properties['_Wrapped Bundle']) continue; // gift-wrapped pairs stay as they are
      const id = it.variant_id + '|' + shown(it);
      if (!seen[id]) { seen[id] = it; continue; }
      updates[seen[id].key] = (updates[seen[id].key] || seen[id].quantity) + it.quantity;
      updates[it.key] = 0;
    }
    if (!Object.keys(updates).length) return;
    // drop the extra lines first, then raise the kept line with change.js: update.js ignores stock (it let a 1-in-stock item sit
    // in the cart twice, Hamza 2026-10-24), change.js caps the line at what is really available
    const drop = {}, keep = {};
    for (const k in updates) (updates[k] === 0 ? drop : keep)[k] = updates[k];
    const post = (url, body) => origFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    await post('/cart/update.js', { updates: drop });
    for (const k in keep) await post('/cart/change.js', { id: k, quantity: keep[k] });
    if (/\/cart\/?$/.test(location.pathname.replace(/^\/ar/, ''))) location.reload();
  };
  let inflight = null, again = false;
  const fix = () => { // a cart change landed mid-run: run once more when done
    if (inflight) { again = true; return inflight; }
    inflight = (async () => { do { again = false; await run(); } while (again); })().finally(() => { inflight = null; });
    return inflight;
  };
  const run = async () => {
    try {
      const cart = await (await origFetch('/cart.js')).json();
      const isWrap = (i) => /^gift-wrap/.test(i.handle || '') || /gift wrap/i.test(i.product_title || ''); // no supplier on gift wrap lines
      const todo = cart.items.filter((i) => isWrap(i) ? !!(i.properties && i.properties[SUP])
        : !(i.properties && i.properties[KEY]) || (i.properties && i.properties[OLD]) || !(i.properties && i.properties[SUP]));
      if (!todo.length) { await merge(); return; }
      const ids = await sameDayIds();
      for (const it of todo) {
        const props = Object.assign({}, it.properties || {});
        let changed = false;
        if (isWrap(it)) { delete props[SUP]; changed = true; }
        else if (ids.has(it.product_id) && !props[KEY]) { props[KEY] = VAL; changed = true; }
        if (props[OLD]) { delete props[OLD]; changed = true; }
        if (!isWrap(it) && !props[SUP]) { // supplier name rendered by templates/product.bjo-supplier.liquid
          const r = await origFetch('/products/' + it.handle + '?view=bjo-supplier');
          const t = r.ok ? (await r.text()).trim() : '';
          // the view prints the name HTML-escaped: decode it, or the order shows "Dr. Brown&#39;s" (#29427, 2026-10-28)
          props[SUP] = t && !t.includes('<') ? new DOMParser().parseFromString(t, 'text/html').documentElement.textContent.slice(0, 200) : 'UNKNOWN';
          changed = true;
        }
        if (!changed) continue;
        await origFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props }) });
      }
      await merge();
    } catch (e) { /* never block the cart */ }
  };
  // Checkout waits (max 4s) for the labels: order #29271 (2026-10-19) went to checkout before the last-added line got _SUPPLIER.
  document.addEventListener('submit', (e) => {
    const f = e.target, s = e.submitter;
    if (!s || s.name !== 'checkout' || f.dataset.bjoReady) return;
    e.preventDefault();
    Promise.race([fix(), new Promise((r) => setTimeout(r, 4000))]).finally(() => { f.dataset.bjoReady = '1'; f.requestSubmit(s); });
  }, true);
  const watch = (url) => { if (/\/cart\/(add|change|update)/.test(url || '')) setTimeout(fix, 400); };
  window.fetch = function (input, init) {
    const p = origFetch(input, init);
    p.then(() => watch(typeof input === 'string' ? input : input && input.url)).catch(() => {});
    return p;
  };
  const open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    this.addEventListener('load', () => watch(String(url)));
    return open.apply(this, arguments);
  };
  fix();
})();
